module.exports = __webpack_public_path__ + "img/mohamadghali3_lazy.0b4cb794.png";